
import { lazy } from 'react';
const PlatformDashboard = lazy(() => import('../views/Platform/Dashboard')); 

const platformRoutes = [
  { path: '/dashboard/platform', component: PlatformDashboard, exact: true }, 
];

export default platformRoutes;
